import { WalletTypeEnum } from '@libs/backend-common';
import { useWalletAssets as useNativeWalletAssets } from '@libs/hooks';
import { useWalletAssetsDetailed } from './useWalletInfo';

export const useWalletAssets = (
  isNoneZeroAsset?: boolean,
  sortByCmcRank = false
) => {
  const {
    walletAssets: response,
    loading: assetsLoading,
    errors,
  } = useWalletAssetsDetailed(
    isNoneZeroAsset
      ? WalletTypeEnum.NON_ZERO_ASSETS
      : WalletTypeEnum.ALL_ASSETS,
    undefined,
    undefined,
    undefined,
    undefined,
    sortByCmcRank
  );

  return useNativeWalletAssets(errors, assetsLoading, response);
};
